import axios from 'axios';
import { BASE_URL } from './config';

axios.defaults.withCredentials = true;

axios.interceptors.request.use(config => {
  const authToken = localStorage.getItem('authToken');
  if (authToken) {
    config.headers['Authorization'] = authToken;
  } else {
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      try {
        const user = JSON.parse(userInfo);
        config.headers['X-User-ID'] = user.user_id;
      } catch (e) {
        console.error('解析用户信息失败:', e);
      }
    }
  }
  return config;
});

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('userInfo');
      localStorage.removeItem('authToken');
      window.dispatchEvent(new CustomEvent('auth-required'));
    }
    return Promise.reject(error);
  }
);

export default axios;